<template>
  <div class="mt-16 mb-8">
    <div class="container mx-auto px-4 max-w-6xl">
      <div class="grid grid-cols-3 md:flex md:flex-row md:flex-nowrap md:justify-center gap-8 md:gap-12 items-center justify-items-center opacity-60 grayscale">
        <NuxtPicture
          v-for="logo in displayLogos"
          :key="logo.src"
          :src="logo.src"
          :alt="logo.alt"
          :class="[
            'w-auto object-contain',
            logo.alt === 'Bein Sport' || logo.alt === 'Palace' 
              ? 'logo-large h-8 md:h-12' 
              : 'h-6 md:h-8'
          ]"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Logo {
  src: string
  alt: string
}

interface Props {
  logos?: Logo[]
}

const defaultLogos: Logo[] = [
  { src: '/medias/logos/Vanity_Fair_logo.svg.png', alt: 'Vanity Fair' },
  { src: '/medias/logos/Madame_Figaro_(logo).svg.png', alt: 'Madame Figaro' },
  { src: '/medias/logos/lofficiel-vector-logo.png', alt: 'L\'Officiel' },
  { src: '/medias/logos/Logo_TF1_2013.svg.webp', alt: 'TF1' },
  { src: '/medias/logos/Logo_Canalplus_1995.svg.webp', alt: 'Canal+' },
  { src: '/medias/logos/Logo_M6_(2020,_fond_clair).svg.png', alt: 'M6' },
  { src: '/medias/logos/France.tv_-_logo_2022.svg.png', alt: 'France.tv' },
  { src: '/medias/logos/Bein_sport_logo.svg', alt: 'Bein Sport' },
  { src: '/medias/logos/BASIC_Magazine_logo.svg.png', alt: 'Basic Magazine' },
  { src: '/medias/logos/LogoPalace2020Web_300x415.png', alt: 'Palace' },
  { src: '/medias/logos/livid-black.png', alt: 'Livid' },
  { src: '/medias/logos/Logo_NOVO19_-_2025.svg.webp', alt: 'Novo' },
]

const props = withDefaults(defineProps<Props>(), {
  logos: undefined
})

const displayLogos = computed(() => props.logos || defaultLogos)
</script>

<style scoped>
:deep(img) {
  height: 1.5rem !important; /* 24px */
  width: auto !important;
  object-fit: contain !important;
}

@media (min-width: 768px) {
  :deep(img) {
    height: 2rem !important; /* 32px */
  }
}

/* Larger logos for Bein Sport and Palace */
:deep(.logo-large img) {
  height: 2rem !important; /* 32px mobile */
  width: auto !important;
  object-fit: contain !important;
}

@media (min-width: 768px) {
  :deep(.logo-large img) {
    height: 3rem !important; /* 48px desktop */
  }
}
</style>

